import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/main.css";
import DespreNoiImage from "../images/about-us.png";
import x from "../images/XLogo.png";
import instagram from "../images/InstagramLogo.png";
import itemLogo from "../images/item-logo.png";
import human from "../images/human.png";
import "../css/main.css";
import facebook from "../images/FacebookLogo.png";
import instagramBlack from "../images/InstagramLogoBlack.png";
import linkedin from "../images/LinkedinLogo.png";

const DespreNoi = () => {
  return (
    <div>
      <Header />
      <div class="despre-noi-page">
        <div className="despre-noi text-b">
          <div className="row">
            <div className="info">
              <div className="info-section text-b">AWARE</div>
              <h1>Despre noi</h1>
              <p className="text-b">
                Într-o lume dinamică, unde ritmul vieții poate deveni
                copleșitor, nevoia de echilibru interior este mai importantă ca
                niciodată. La Aware, ne dedicăm sprijinirii fiecărei persoane în
                procesul de autocunoaștere, gestionare a emoțiilor și dezvoltare
                personală. Credem că fiecare individ merită să trăiască o viață
                conștientă, autentică și împlinită.
              </p>
              <p className="text-b">
                Suntem o echipă de specialiști pasionați de psihologie, care îți
                oferă un spațiu sigur, unde te poți exprima liber, fără teama de
                a fi judecat. Printr-o abordare personalizată și bazată pe
                metode validate științific, te ghidăm în procesul de explorare a
                gândurilor și emoțiilor tale.
              </p>
              <h2 className="text-b">Cui ne adresăm?</h2>
              <p className="text-b">
                Indiferent dacă te confrunți cu stres, anxietate, dificultăți în
                relații sau pur și simplu îți dorești o mai bună înțelegere a
                sinelui, suntem aici pentru tine. Fiecare pas spre
                autocunoaștere este un act de curaj, iar noi suntem pregătiți să
                te ghidăm în această călătorie.
              </p>
              <p className="text-b">
                Fiecare pas spre autocunoaștere este un act de curaj, iar noi
                suntem pregătiți să te ghidăm în această călătorie. Împreună,
                putem transforma provocările în oportunități de creștere și
                evoluție personală.
              </p>
            </div>
            <div className="image">
              <img alt="background test" src={DespreNoiImage} />
            </div>
          </div>
        </div>
        <div className="characteristics">
          <h2 className="text-b">Ce ne definește?</h2>
          <div className="row">
            <div className="item">
              <div className="box">
                <h3>Empatie și profesionalism</h3>
                <p>
                  fiecare călătorie este unică, iar noi suntem aici să te
                  susținem la fiecare pas.
                </p>
              </div>
            </div>
            <div className="item">
              <div className="box">
                <h3>Un mediu sigur și încurajator</h3>
                <p>
                  un spațiu de încredere unde poți găsi răspunsuri la
                  întrebările tale.
                </p>
              </div>
            </div>
            <div className="item">
              <div className="box">
                <h3>O abordare holistică </h3>
                <p>
                  combinăm metode din psihologia cognitiv-comportamentală,
                  mindfulness și terapii experiențiale pentru a oferi soluții
                  adaptate fiecărei persoane.
                </p>
              </div>
            </div>
          </div>
          <a href="/" className="see-more text-b">
            Vezi contribuțiile noastre
          </a>
        </div>
        <div className="team-aware">
          <div className="grid-4 grid-2">
            <div className="item">
              <div className="image">
                <img className="item-image" src={human} alt="therapist" />
                <div className="logo-tag">
                  <img alt="logo tag icon" src={itemLogo} />
                </div>
                <div className="social-bar">
                  <a href="/" className="social">
                    <img alt="icon-social" src={facebook} />
                  </a>
                  <a href="/" className="social x">
                    <img alt="icon-social" src={x} />
                  </a>
                  <a href="/" className="social">
                    <img alt="icon-social" src={linkedin} />
                  </a>
                  <a href="/" className="social">
                    <img alt="icon-social" src={instagramBlack} />
                  </a>
                </div>
              </div>
              <h3 className="text-b">Dr. Emily Stevens</h3>
              <p> Lead Therapist</p>
              <div className="description">
                Fiecare pas spre autocunoaștere este un act de curaj, iar noi
                suntem pregătiți să te ghidăm în această călătorie. Împreună,
                putem transforma provocările în oportunități de creștere și
                evoluție personală. Fiecare pas spre autocunoaștere este un act
                de curaj, iar noi suntem pregătiți să te ghidăm în această
                călătorie. Împreună, putem transforma provocările în
                oportunități de creștere și evoluție personală.Fiecare pas spre
                autocunoaștere este un act.
              </div>
            </div>
            <div className="item">
              <div className="image">
                <img className="item-image" src={human} alt="therapist" />
                <div className="logo-tag">
                  <img alt="social-icon" src={itemLogo} />
                </div>
                <div className="social-bar">
                  <a href="/" className="social">
                    <img alt="social-icon" src={facebook} />
                  </a>
                  <a href="/" className="social x">
                    <img alt="social-icon" src={x} />
                  </a>
                  <a href="/" className="social">
                    <img alt="social-icon" src={linkedin} />
                  </a>
                  <a href="/" className="social">
                    <img alt="social-icon" src={instagram} />
                  </a>
                </div>
              </div>
              <h3 className="text-b">Dr. Emily Stevens</h3>
              <p> Lead Therapist</p>
              <div className="description">
                Fiecare pas spre autocunoaștere este un act de curaj, iar noi
                suntem pregătiți să te ghidăm în această călătorie. Împreună,
                putem transforma provocările în oportunități de creștere și
                evoluție personală. Fiecare pas spre autocunoaștere este un act
                de curaj, iar noi suntem pregătiți să te ghidăm în această
                călătorie. Împreună, putem transforma provocările în
                oportunități de creștere și evoluție personală.Fiecare pas spre
                autocunoaștere este un act.
              </div>
            </div>
            <div className="item">
              <div className="image">
                <img className="item-image" src={human} alt="therapist " />
                <div className="logo-tag">
                  <img alt="social-icon" src={itemLogo} />
                </div>
                <div className="social-bar">
                  <a href="/" className="social">
                    <img alt="social-icon" src={facebook} />
                  </a>
                  <a href="/" className="social x">
                    <img alt="social-icon" src={x} />
                  </a>
                  <a href="/" className="social">
                    <img alt="social-icon" src={linkedin} />
                  </a>
                  <a href="/" className="social">
                    <img alt="social-icon" src={instagram} />
                  </a>
                </div>
              </div>
              <h3 className="text-b">Dr. Emily Stevens</h3>
              <p> Lead Therapist</p>
              <div className="description">
                Fiecare pas spre autocunoaștere este un act de curaj, iar noi
                suntem pregătiți să te ghidăm în această călătorie. Împreună,
                putem transforma provocările în oportunități de creștere și
                evoluție personală. Fiecare pas spre autocunoaștere este un act
                de curaj, iar noi suntem pregătiți să te ghidăm în această
                călătorie. Împreună, putem transforma provocările în
                oportunități de creștere și evoluție personală.Fiecare pas spre
                autocunoaștere este un act.
              </div>
            </div>
            <div className="item">
              <div className="image">
                <img className="item-image" src={human} alt="therapist " />
                <div className="logo-tag">
                  <img alt="social-icon" src={itemLogo} />
                </div>
                <div className="social-bar">
                  <a href="/" className="social">
                    <img alt="social-icon" src={facebook} />
                  </a>
                  <a href="/" className="social x">
                    <img alt="social-icon" src={x} />
                  </a>
                  <a href="/" className="social">
                    <img alt="social-icon" src={linkedin} />
                  </a>
                  <a href="/" className="social">
                    <img alt="social-icon" src={instagram} />
                  </a>
                </div>
              </div>
              <h3 className="text-b">Dr. Emily Stevens</h3>
              <p> Lead Therapist</p>
              <div className="description">
                Fiecare pas spre autocunoaștere este un act de curaj, iar noi
                suntem pregătiți să te ghidăm în această călătorie. Împreună,
                putem transforma provocările în oportunități de creștere și
                evoluție personală. Fiecare pas spre autocunoaștere este un act
                de curaj, iar noi suntem pregătiți să te ghidăm în această
                călătorie. Împreună, putem transforma provocările în
                oportunități de creștere și evoluție personală.Fiecare pas spre
                autocunoaștere este un act.
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DespreNoi;
